import * as t from 'io-ts';

export const DuplicateVinErrorResponseCodec = t.type({
    status: t.literal(400),
    data: t.type({
        detail: t.string,
        error_code: t.literal('duplicate-vin'),
    }),
});
